import React from 'react';

import { Stack } from '@atlaskit/primitives';

import { useParams } from 'src/router/hooks';
import { CommitTable } from 'src/sections/repository/components/commit-list';
import { SyncBranchInfo } from 'src/sections/repository/sections/pull-request/components/tabs/sync-branch-info';

import { usePullRequestCommitListDetails } from '../../hooks/commit-list/pull-request-commit-list';

export const CommitTab = ({
  isLoadingConflicts,
}: {
  isLoadingConflicts: boolean;
}) => {
  const {
    commits,
    isLoading,
    hasError,
    hasMore,
    retryAction,
    fetchMoreAction,
  } = usePullRequestCommitListDetails();

  const { repositoryOwner, repositorySlug } = useParams<{
    repositoryOwner: string;
    repositorySlug: string;
  }>();

  const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;

  return (
    <Stack space="space.200" grow="fill">
      <SyncBranchInfo isLoadingConflicts={isLoadingConflicts} />
      <CommitTable
        repositoryFullSlug={repositoryFullSlug}
        isLoading={isLoading}
        hasError={hasError}
        commits={commits}
        hasMore={hasMore}
        retryAction={retryAction}
        fetchMoreAction={fetchMoreAction}
      />
    </Stack>
  );
};
